import { fromJS } from 'immutable';

import {
  FETCH_INVOICES_SUCCESS,
  FETCH_INVOICES_FAILED,
  FETCH_INVOICE_SUCCESS,
  FETCH_INVOICE_FAILED,
} from '../actions/billing';

const initialState = fromJS({
  invoices: [],
  invoice: {},
  loading: false,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_INVOICES_SUCCESS:
      return state.set('loading', false)
        .set('invoices', fromJS(action.invoices));
    case FETCH_INVOICES_FAILED:
      return state.set('loading', false)
        .set('error', fromJS(action.error));
    case FETCH_INVOICE_SUCCESS:
      return state.set('loading', false)
        .set('invoice', fromJS(action.invoice));
    case FETCH_INVOICE_FAILED:
      return state.set('loading', false)
        .set('error', fromJS(action.error));
    default :
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/billing.js